module.exports = __webpack_public_path__ + "img/undraw_checking_boxes_2ibd.7b0f61e0.svg";